import { RequestState } from "../utils";

export const isKeycloakReady = (state) => {
  return state.keycloak.ready;
};

export const isKeycloakAuthenticated = (state) => {
  return state.keycloak.authenticated;
};

export const userHasRole = (state, role) => {
  return state.keycloak.userToken?.cern_roles?.includes(role) || false;
};

export const userId = (state) => {
  return state.keycloak.userToken?.sub || false;
};

export const applicationsList = (state) => {
  return state.applications;
};

export const isApplicationSelected = (state) => {
  return state.active_application.active;
};

export const getActiveApplication = (state) => {
  return state.active_application;
};

export const getApplicationRoles = (state) => {
  return state.active_application.roles;
};

export const getErrors = (state) => {
  return state.errors;
};

export const isLoading = (state, name) => {
  return state.requests[name].state === RequestState.STARTED;
};

export const getAllProviders = (state) => {
  return state.providers;
};

export const getGroups = (state) => {
  return state.groups;
};

export const getRole = (state, id) => {
  return state.active_application.roles.find((element) => element.id === id);
};

export const getActiveRole = (state) => {
  return state.active_role;
};

export const getRegistrationDetails = (state) => {
  return state.active_application.new_registration;
};

export const getSecretDetails = (state) => {
  return state.active_application.new_secret;
};

export const selectBreadcrumbs = (state) => {
  return state.breadcrumbs.nav;
};

export const getApplicationOwner = (state) => {
  return state.active_application.owner;
};

export const selectFocusedRequest = (state, id) => {
  let request = state.applicationRequests.toApprove.find((r) => r.id === id);
  if (request) {
    return {
      request,
      toApprove: true,
    };
  } else {
    return {
      request: state.applicationRequests.my.find((r) => r.id === id),
      toApprove: false,
    };
  }
};

export const getAllLevelsOfAssurance = (state) => {
  return state.levelsOfAssurance;
};

export const applicationsListV2 = (state) => {
  return state.applicationsV2;
};
